import React from 'react';
import './main.css';
import t from '../../../i8n';

const PARTNERS = [
	{name: 'Helpful Company Sp.z o.o.', logo: 'gfx/partners/helpfulcompany.png', url: 'http://helpfulcompany.pl'},
	{name: 'Anzonia Sp.z o.o.', logo: 'gfx/partners/anzonia.svg', url: 'http://anzonia.pl'}
];

export default
class WspolpracaScreen extends React.Component {
	render(){
		return (
			<div>
				<h3>
					{t({pl: 'Mam przyjemność pracować między innymi z:', en: 'I have the pleasure of working with:'})}
				</h3>
				<div className="logo-grid">
					{PARTNERS.map((v,k) => (
						<div key={k} className="logo-grid-item">
							<a href={v.url}>
								<img src={v.logo} />
							</a>
						</div>
					))}
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/Content/Screens/Wspolpraca/index.js